import { getLineItemImageUrl } from '../../../../../utils/get-line-item-image-url.js';
import { getLineItemName } from '../../../../../utils/get-line-item-name.js';

const getSolutionProperties = (solutionProduct, intl)=>{
    return {
        solutionSku: solutionProduct.sku,
        solutionName: getLineItemName(solutionProduct, intl.locale),
        solutionImageUrl: getLineItemImageUrl(solutionProduct.masterData.current.variant)
    };
};

export { getSolutionProperties };
//# sourceMappingURL=get-solution-properties.js.map
